export const ComponentRoutes = {
    auth: {
        root: "auth",
    },
    offers: {
        root: "offers",
        offer: "offers/offer/:offerId",
        offerGoals: "offers/offer/:offerId/goals",
        statistics: "offersStatistics",
    },
    targetGroups: {
        root: "target-groups",
        group: "target-groups/:groupId",
    },
    achievements: {
        root: "achievements",
        achievement: "achievements/:achievementId",
    },
    quests: {
        root: "quests",
        quest: "quests/:questId",
        template: "quests/templates/:templateId",
    },
    users: {
        root: "users",
        user: "users/:email",
    },
    spinWheel: {
        root: "spin-wheel",
    },
    banners: {
        root: "banners",
    },
    abTests: {
        root: "ab-tests",
        test: "ab-tests/:abTestId",
    },
    health: {
        root: "app-health"
    },
    clients: {
        root: "clients",
    }
};
